// extracted by mini-css-extract-plugin
export var accountNav = "account-nav-module--account-nav--604f8";
export var active = "account-nav-module--active--041f1";
export var labelBox = "account-nav-module--label-box--393a4";
export var link = "account-nav-module--link--66597";